var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpadion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3875 0.8875L11.475 1.975L9.84 3.595C9.5475 3.8875 9.5475 4.3675 9.84 4.66C10.1325 4.9525 10.6125 4.9525 10.905 4.66L12.525 3.025L13.6125 4.1125C13.845 4.345 14.25 4.18 14.25 3.8425V0.625C14.25 0.415 14.085 0.25 13.875 0.25H10.6575C10.32 0.25 10.155 0.655 10.3875 0.8875ZM1.3875 4.1125L2.475 3.025L4.095 4.66C4.3875 4.9525 4.8675 4.9525 5.16 4.66C5.4525 4.3675 5.4525 3.8875 5.16 3.595L3.525 1.975L4.6125 0.8875C4.845 0.655 4.68 0.25 4.3425 0.25H1.125C0.915 0.25 0.75 0.415 0.75 0.625V3.8425C0.75 4.18 1.155 4.345 1.3875 4.1125ZM4.6125 13.1125L3.525 12.025L5.16 10.405C5.4525 10.1125 5.4525 9.6325 5.16 9.34C4.8675 9.0475 4.3875 9.0475 4.095 9.34L2.475 10.975L1.3875 9.8875C1.155 9.655 0.75 9.82 0.75 10.1575V13.375C0.75 13.585 0.915 13.75 1.125 13.75H4.3425C4.68 13.75 4.845 13.345 4.6125 13.1125ZM13.6125 9.8875L12.525 10.975L10.905 9.34C10.6125 9.0475 10.1325 9.0475 9.84 9.34C9.5475 9.6325 9.5475 10.1125 9.84 10.405L11.475 12.025L10.3875 13.1125C10.155 13.345 10.32 13.75 10.6575 13.75H13.875C14.085 13.75 14.25 13.585 14.25 13.375V10.1575C14.25 9.82 13.845 9.655 13.6125 9.8875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpadion);
export default __webpack_public_path__ + "static/media/iconExpadion.1148035f.svg";
export { ForwardRef as ReactComponent };